import Vue from 'vue'
import VueRouter, { NavigationGuard, RouterOptions } from 'vue-router'
import { Store } from 'vuex/types'
import { IRootState } from '@/store'
import types from '@/store/all-action-types' 
 
Vue.use(VueRouter)

const routes = [
  { 
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "index" */ '@/views/Home.vue')
  }, 
  { 
    path: '/roomservice',
    name: 'RoomService',
    component: () => import(/* webpackChunkName: "room-service" */ '@/views/RoomService.vue'),
    props(route: any) {              
      return { 
        ...route.params, 
        sectionId:parseInt(route.params.sectionId), 
        pageId:parseInt(route.params.pageId)
      }
    }
  },
  {
    path: '/login',
    name: 'Login',    
    component: () => import(/* webpackChunkName: "index" */ '@/views/Login.vue')
  },
  {
    path: '/create-password',
    name: 'CreatePassword',
    component: () => import(/* webpackChunkName: "index" */ '@/views/CreatePassword.vue')
  },
  {
    path: '/sejours', 
    name: 'Sejour',
    component: () => import(/* webpackChunkName: "reception" */ '@/views/reception/GestionSejour.vue'),
    meta:{roles:["Reception","RoomService"]} 
  },
  {
    path: '/sejours/new',
    name: 'NewSejour', 
    component: () => import(/* webpackChunkName: "reception" */ '@/views/reception/ModifySejour.vue'),
    props(route: any) {    
      console.log(route.params)          
      return { ...route.params, sejourId:-1, useUser:route.params?.useUser=="1" }
    }   
  },
  {
    path: '/sejours/:sejourId',
    name: 'ModifySejour', 
    component: () => import(/* webpackChunkName: "reception" */ '@/views/reception/ModifySejour.vue'),
    props(route: any) {              
      return { ...route.params, sejourId:parseInt(route?.params?.sejourId ?? -1)  }
    },
    meta:{roles:["Reception","RoomService"]}      
  },  
  {
    path: '/historique', 
    name: 'OrderHistory',
    component: () => import(/* webpackChunkName: "index" */ '@/views/compte/OrderHistory.vue'),
    meta:{roles:["Client","Reception","RoomService"]} 
  },
  {
    path: '/historique/:commandeId',
    name: 'DetailHistory', 
    component: () => import(/* webpackChunkName: "index" */ '@/views/compte/DetailHistory.vue'),
    props(route: any) {              
      return { ...route.params, commandeId:parseInt(route?.params?.commandeId ?? -1)  }
    },
    meta:{roles:["Client","Reception","RoomService"]} 
  },
  {
    path: '/commandes', 
    name: 'Commande',
    component: () => import(/* webpackChunkName: "roomservice" */ '@/views/roomServices/GestionCommande.vue'),
    meta:{roles:["RoomService"]} 
  },
  {
    path: '/commandes/:commandeId',
    name: 'ModifyCommande', 
    component: () => import(/* webpackChunkName: "admin" */ '@/views/roomServices/ModifyCommande.vue'),
    props(route: any) {              
      return { ...route.params, commandeId:parseInt(route?.params?.commandeId ?? -1)  }
    },
    meta:{roles:["RoomService","Admin"]}         
  },
  {
    path: '/utilisateurs', 
    name: 'User',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/users/GestionUser.vue'),
    meta:{roles:["Admin"]} 
  },
  {
    path: '/utilisateurs/:userId',
    name: 'ModifyUser', 
    component: () => import(/* webpackChunkName: "admin" */ '@/views/users/ModifyUser.vue'),
    props(route: any) {              
      return { ...route.params, userId:route?.params?.userId=='new'?-1:parseInt(route?.params?.userId ?? -1)  }
    },
    meta:{roles:["Admin"]}      
  },
  {
    path: '/parametres/templates', 
    name: 'MailTemplate',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/mailTemplate/GestionMailTemplate.vue'),
    meta:{roles:["Admin"]} 
  },
  {
    path: '/parametres/skins',
    name: 'MailSkin',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/mailSkin/GestionMailSkin.vue'),
    meta:{roles:["Admin"]} 
  },
  {
    path: '/parametres/qrcode',
    name: 'QrCode',
    component: () => import(/* webpackChunkName: "admin" */ '@/views/qrCode/GestionQrCode.vue'),
    meta:{roles:["Admin"]} 
    
  }
]

export default (store: Store<IRootState>) => {
  
    //@ts-ignore
  const router = new VueRouter({
    //mode: 'history',
    //@ts-ignore
    routes
  })

  //mise ne place de la securité test pour chaque route demandée
  router.beforeEach(((to, from, next) => {        
    if((to.meta?.roles?.length ?? 0) > 0 ) {      
      if(store.getters.canAccess(to.meta?.roles)) {        
        next()
        return
      }  
      else {        
        store.dispatch(types.AUTH_SET_REDIRECT_PATH, to.path)
        next({name:'Login'})        
        return
      }    
    }     
    else {
      next()
      return
    }

  }) as NavigationGuard) 
  
  return router
}
